import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { PollsService } from "./polls.service";
import { ResponseTranslation } from "../shared/translation.service";
import { Router } from "@angular/router";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "edit-poll",
  template: require('./createpoll.component.html'),
  styles: [require('./createpoll.component.scss')]
})
export class EditPollComponent implements OnInit {
  poll: any;
  translations: any[] = [];
  languages: any[] = this.getLanguages();
  clicked: boolean = false;
  responseValues: any[] = [];
  activePanels: string[] = ["status", "visibility"];
  editMode: boolean = true;
  sent: boolean = false;
  @ViewChild("modalTemplate") private modalComponent: TemplateRef<any>;
  dialog: NgbModalRef;

  constructor(
    private service: PollsService,
    private modalService: NgbModal,
    private router: Router
  ) {}

  ngOnInit() {
    this.poll = PollsService.currentPoll;
    if (this.poll) {
      this.translations = this.getTranslations();
    } else {
      this.router.navigate(["/polls"]);
    }
  }

  getLanguages(): any[] {
    return this.service.getLanguages();
  }

  getTranslations() {
    let translations = [];
    Object.keys(this.poll.content).map((key, index) => {
      let it = this.poll.content[key];
      let t = new ResponseTranslation();
      t.language = key;
      t.description = it.description;
      t.question = it.question;
      t.title = it.title;
      t.author = it.author;
      t.responseTexts = [];
      it.responses.map((response) => {
        t.responseTexts.push(response.text);
        if (this.responseValues.length < it.responses.length) {
          this.responseValues.push({ value: response.value });
        }
      });
      translations.push(t);
      this.activePanels.push("translations" + (translations.length - 1));
    });
    return translations;
  }

  getPanelTitle(translation: ResponseTranslation, first: boolean) {
    let text;
    let selectedLang = this.languages.filter((language: any) => {
      return language.key === translation.language;
    })[0];
    text =
      selectedLang && selectedLang.value
        ? selectedLang.value
        : "Choose a language";
    if (first) {
      text += " (Default)";
    }
    return text;
  }

  addTranslation() {
    let t;
    t = new ResponseTranslation();
    if (this.responseValues) {
      this.responseValues.map((r) => {
        t.responseTexts.push("");
      });
    }
    this.translations.push(t);
    this.activePanels.push("translations" + (this.translations.length - 1));
  }

  deleteTranslation(item: any) {
    let index = this.translations.indexOf(item);
    if (index > -1) {
      this.translations.splice(index, 1);
      this.activePanels.splice(this.activePanels.length - 1, 1);
    }
  }

  setDefault(index: number) {
    let t = this.translations[0];
    this.translations[0] = this.translations[index];
    this.translations[index] = t;
  }

  move(from: number, to: number) {
    let backup = this.responseValues[from];
    this.responseValues[from] = this.responseValues[to];
    this.responseValues[to] = backup;
    this.translations.map((translation) => {
      let back = translation.responseTexts[from];
      translation.responseTexts[from] = translation.responseTexts[to];
      translation.responseTexts[to] = back;
    });
  }

  delete(index: number) {
    if (window.confirm("Are you sure?")) {
      this.responseValues.splice(index, 1);
      this.translations.map((translation) => {
        translation.responseTexts.splice(index, 1);
      });
    }
  }

  onSubmit() {
    this.activePanels = [];
    setTimeout(() => {
      this.save();
    }, 1);
  }

  save() {
    if (!this.clicked) {
      this.clicked = true;
      let defLang;
      this.translations.map((it: any) => {
        if (it.language !== "") {
          if (!defLang) {
            defLang = it.language;
          }
          this.poll.content[it.language] = {
            author: it.author,
            title: it.title,
            question: it.question,
            description: it.description,
            responses: []
          };
          let index = 0;
          this.responseValues.map((v) => {
            this.poll.content[it.language].responses.push({
              value: v.value,
              text: it.responseTexts[index]
            });
            index++;
          });
        }
      });
      this.poll.default_lang = defLang;
      let pollCopy = Object.assign({}, this.poll);
      delete pollCopy.context.employerNames;
      delete pollCopy.context.projectNames;
      delete pollCopy.responseCount;
      delete pollCopy.responses;
      this.service.editPoll(pollCopy).subscribe(
        (response) => {
          this.clicked = false;
          this.back();
        },
        (error) => {
          this.activePanels = ["status", "visibility"];
          this.translations.map((it, index) => {
            this.activePanels.push("translations" + index);
          });
          this.clicked = false;
        }
      );
    }
  }

  showModal() {
    if (!this.sent) {
      this.dialog = this.modalService.open(this.modalComponent);
    }
  }

  deletePoll(result) {
    this.dialog.close();
    if (result) {
      this.sent = true;
      this.service.deletePoll(this.poll.id).subscribe(
        (res) => {
          this.back();
        },
        (error) => {
          this.sent = false;
        }
      );
    }
  }

  back() {
    window.history.back();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/polls/editpoll.component.ts